'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var S3 = (_temp = _class = function (_SvgIcon) {
  _inherits(S3, _SvgIcon);

  function S3() {
    _classCallCheck(this, S3);

    return _possibleConstructorReturn(this, (S3.__proto__ || Object.getPrototypeOf(S3)).apply(this, arguments));
  }

  _createClass(S3, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'text' },
            _react2['default'].createElement('path', {
              d: 'M19.326 28.367a5.753 5.753 0 0 0 .21 1.7 10.2 10.2 0 0 0 .611 1.375.83.83 0 0 1 .133.439.756.756 0 0 1-.362.572l-1.2.8a.917.917 0 0 1-.5.171.878.878 0 0 1-.573-.267 5.881 5.881 0 0 1-.687-.9c-.19-.324-.381-.687-.591-1.126a7.051 7.051 0 0 1-5.611 2.634 5.23 5.23 0 0 1-3.816-1.371 4.9 4.9 0 0 1-1.412-3.664 4.911 4.911 0 0 1 1.737-3.93 6.944 6.944 0 0 1 4.675-1.49 15.174 15.174 0 0 1 2.023.152c.706.1 1.432.248 2.2.42v-1.393a4.23 4.23 0 0 0-.9-3.054 4.4 4.4 0 0 0-3.111-.877 8.669 8.669 0 0 0-2.061.248 14.993 14.993 0 0 0-2.061.649 5.678 5.678 0 0 1-.668.248 1.178 1.178 0 0 1-.305.057c-.268 0-.4-.191-.4-.592v-.935a1.214 1.214 0 0 1 .133-.668 1.45 1.45 0 0 1 .535-.4 11.012 11.012 0 0 1 2.4-.858 11.54 11.54 0 0 1 2.978-.363c2.271 0 3.931.515 5 1.546a6.317 6.317 0 0 1 1.584 4.7v6.183zm-7.748 2.9a6.186 6.186 0 0 0 1.965-.344 4.255 4.255 0 0 0 1.813-1.223 3.014 3.014 0 0 0 .649-1.222 6.822 6.822 0 0 0 .191-1.66v-.8a15.735 15.735 0 0 0-1.756-.318 14.431 14.431 0 0 0-1.794-.114 4.4 4.4 0 0 0-2.843.763 2.66 2.66 0 0 0-.935 2.2 2.664 2.664 0 0 0 .706 2.023 2.647 2.647 0 0 0 2.004.696zM26.9 33.329a1.064 1.064 0 0 1-.725-.191 1.565 1.565 0 0 1-.4-.744l-4.483-14.752a3.322 3.322 0 0 1-.172-.764.419.419 0 0 1 .458-.477h1.87a1.053 1.053 0 0 1 .744.191 1.553 1.553 0 0 1 .382.744L27.78 29.97l2.978-12.634a1.33 1.33 0 0 1 .362-.744 1.309 1.309 0 0 1 .763-.191h1.527a1.148 1.148 0 0 1 .764.191 1.287 1.287 0 0 1 .362.744l3.016 12.787 3.3-12.787a1.631 1.631 0 0 1 .382-.744 1.242 1.242 0 0 1 .744-.191h1.775a.424.424 0 0 1 .477.477 1.892 1.892 0 0 1-.038.3 2.654 2.654 0 0 1-.134.478l-4.6 14.752a1.452 1.452 0 0 1-.4.744 1.216 1.216 0 0 1-.725.191h-1.64a1.148 1.148 0 0 1-.764-.191 1.354 1.354 0 0 1-.362-.763l-2.958-12.31-2.939 12.296a1.49 1.49 0 0 1-.363.763 1.181 1.181 0 0 1-.763.191zm24.524.515a12.63 12.63 0 0 1-2.939-.343 8.653 8.653 0 0 1-2.2-.764 1.366 1.366 0 0 1-.585-.537 1.338 1.338 0 0 1-.115-.534V30.7c0-.4.153-.591.439-.591a1.088 1.088 0 0 1 .344.057c.114.038.286.114.477.191a10.424 10.424 0 0 0 2.1.668 11.511 11.511 0 0 0 2.271.229A5.145 5.145 0 0 0 54 30.619a2.056 2.056 0 0 0 1-1.813 1.862 1.862 0 0 0-.515-1.336 4.786 4.786 0 0 0-1.928-.992l-2.767-.859a5.824 5.824 0 0 1-3.054-1.947 4.546 4.546 0 0 1-.954-2.767 4.248 4.248 0 0 1 .515-2.118 4.918 4.918 0 0 1 1.374-1.565 6.066 6.066 0 0 1 1.985-.993 8.322 8.322 0 0 1 2.4-.324 9.6 9.6 0 0 1 1.278.076c.439.057.84.134 1.241.21.382.1.744.191 1.088.3a4.174 4.174 0 0 1 .8.344 1.66 1.66 0 0 1 .573.477 1.034 1.034 0 0 1 .172.63v.9c0 .4-.153.611-.439.611a2 2 0 0 1-.726-.229 8.715 8.715 0 0 0-3.664-.745 4.921 4.921 0 0 0-2.538.535 1.841 1.841 0 0 0-.9 1.7 1.8 1.8 0 0 0 .573 1.355 5.691 5.691 0 0 0 2.1 1.05l2.71.859a5.8 5.8 0 0 1 2.958 1.832 4.314 4.314 0 0 1 .878 2.671 4.912 4.912 0 0 1-.5 2.214 5.137 5.137 0 0 1-1.394 1.68 6.14 6.14 0 0 1-2.118 1.068 9.051 9.051 0 0 1-2.722.401z',
              fill: '#252f3e'
            }),
            _react2['default'].createElement('path', {
              d: 'M55.033 43.119c-6.279 4.638-15.4 7.1-23.245 7.1A42.054 42.054 0 0 1 3.409 39.4c-.591-.535-.057-1.26.649-.84a57.23 57.23 0 0 0 28.4 7.538 56.67 56.67 0 0 0 21.661-4.427c1.048-.479 1.945.685.914 1.448z',
              fill: '#f90',
              fillRule: 'evenodd'
            }),
            _react2['default'].createElement('path', {
              d: 'M57.648 40.142c-.8-1.03-5.306-.5-7.348-.248-.611.076-.706-.458-.153-.859 3.588-2.519 9.485-1.794 10.172-.954.687.859-.19 6.756-3.549 9.58-.516.439-1.012.21-.783-.362.764-1.89 2.462-6.145 1.661-7.157z',
              fill: '#f90',
              fillRule: 'evenodd'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return S3;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = S3;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/S3.js
// module id = 1400
// module chunks = 32